import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Link from 'react-router/lib/Link'
import Panel from 'react-bootstrap/lib/Panel'
import SearchIcon from 'react-icons/lib/md/search'
import Mousetrap from 'mousetrap'

import SearchModalSubjectOffering from 'components/SearchModalSubjectOffering'

import { searchOffering } from './actions'

class Offerings extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openSearch: false,
    }
  }

  componentDidMount() {
    Mousetrap.bind(['a'], this._linkNew)
    Mousetrap.bind(['q'], this._showSearch)
  }

  componentWillUnmount() {
    Mousetrap.unbind(['a'], this._linkNew)
    Mousetrap.unbind(['q'], this._showSearch)
  }

  _showSearch = () => {
    this.setState({
      openSearch: true,
    })
  }

  _hideSearch = () => {
    this.setState({
      openSearch: false,
    })
  }

  _onSearch = (term) => {
    this.props.dispatch(searchOffering(term))
  }

  _onSelectItem = (item) => {
    this._hideSearch()
    this.context.router.push(`/setup/offerings/${item.get('id')}`)
  }

  _linkNew = () => {
    this.context.router.push('/setup/offerings/new')
  }

  _renderSearch() {
    const { openSearch } = this.state
    const { __results } = this.props

    if (!openSearch) {
      return null
    }

    return (
      <SearchModalSubjectOffering
        placeholder="Search Offering Subject Code"
        handleClose={this._hideSearch}
        onSubmit={this._onSearch}
        results={__results}
        onSelectItem={this._onSelectItem}
      />
    )
  }

  render() {
    const { children } = this.props

    const header = (
      <div className="row">
        <div className="col-sm-8">Subject Offerings</div>
        <div className="col-sm-4 text-right">
          <Link to="/setup/offerings/new" className="btn-icon btn-inline">+</Link>
          <button type="button" onClick={this._showSearch} className="btn-icon btn-inline"><SearchIcon /></button>
        </div>
      </div>
    )

    return (
      <Panel header={header}>
        { React.cloneElement(children, { onSearchForm: this._showSearch }) }
        {this._renderSearch()}
      </Panel>
    )
  }
}

Offerings.contextTypes = {
  router: PropTypes.object,
}

Offerings.propTypes = {
  __results: PropTypes.object,
  children: PropTypes.any,
}

function mapStateToProps(state) {
  return {
    __results: state.offering.get('searchResults'),
  }
}

export default connect(mapStateToProps)(Offerings)



// WEBPACK FOOTER //
// ./src/containers/Setup/Offerings/index.js